import { ProductSDK } from '@b2ag/module-product-sdk'
import ImportService from '@/services/import.service'

export default class ProductsAdditionalDataService {
  // `productSdk` (sans timeout) pour l'import d'un CSV volumineux, `productSdkWithTimeout`
  // pour l'export, qui était plafonné à 20 s avant le passage au SDK.
  constructor(
    private readonly productSdk: ProductSDK,
    private readonly productSdkWithTimeout: ProductSDK,
  ) {}

  async import(distributorId: number, file: any) {
    return await this.productSdk.putDistributorProduct({ partnerId: String(distributorId) }, file)
  }

  async downloadProductsAdditionalDataCSV(distributorId: number, partnerName: string) {
    // L'endpoint ne sert que du CSV : le SDK renvoie directement le contenu du fichier.
    const csv = await this.productSdkWithTimeout.getDistributorProductsCsv({ partnerId: String(distributorId) })

    const url = window.URL.createObjectURL(new Blob([csv]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', ImportService.createFileName(partnerName, 'products-additional-data'))
    document.body.appendChild(link)
    link.click()
  }
}
